import { Children } from "react";
import { Box, LinearProgress } from "@mui/material";
import { PDFViewer, Document, View } from "@react-pdf/renderer";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { PDFCabeçalho } from "src/Pages/components/PDF/Cabeçalho";
import { ItemMapToInfoSearch } from "src/Pages/components/PDF/ItemMapToInfoSearch";
import { NumberPages } from "src/Pages/components/PDF/NumberPages";
import { PageCorePDF } from "src/Pages/components/PDF/PageCorePDF";
import { TableBase } from "src/Pages/components/PDF/TableBase";
import { PDFTableRow } from "src/Pages/components/PDF/TableRow";
import { TableRowContainer } from "src/Pages/components/PDF/TableRowContainer";
import { handleFormatDateWithHours } from "src/shared/Utils/FormatDate/FormatDateToCodeProcucer";
import { FormatDateBR, GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { HandleGetHoursCurrency } from "src/shared/Utils/HandleGetHoursCurrency";

import { HeadReportProductionGerente } from "./HeadReportProductionGerentePDF";

export const ReportProductionGerentePDF = () => {
  const { userPerfil } = useAuthContext();
  const { loadingGravar } = useConfigPageContext();
  const { listReportProductionGerente } = useContextReportsProduction();

  const data = listReportProductionGerente?.data;
  const meta = listReportProductionGerente?.meta;

  const total = (data || []).reduce(
    (acc, current) => ({
      totalMensalidades: acc.totalMensalidades + Number(current.total_mensalidades),
      totalContratos: acc.totalContratos + Number(current.total_contratos),
      totalVidas: acc.totalVidas + Number(current.total_vidas),
    }),
    {
      totalMensalidades: 0,
      totalContratos: 0,
      totalVidas: 0,
    }
  );

  const tiposDate = {
    VIGENCIA: "Vigência",
    ASSINATURA: "Assinatura",
    EMISSAO: "Emissão",
    VENCIMENTO: "Vencimento",
  };

  return (
    <>
      {userPerfil && data?.length && meta && (
        <PDFViewer style={{ height: "84vh" }} width="100%">
          <Document
            creator="Brokeris"
            title={
              meta?.id_gerente
                ? `Relatório de produção de gerente-${handleFormatDateWithHours()}`
                : "Relatório de produção de gerente"
            }
          >
            <PageCorePDF
              key={meta.count}
              orientation="portrait"
              padding="16px 8px 30px 8px"
            >
              {meta?.start_date && meta?.end_date && (
                <PDFCabeçalho
                  dateCurrency={FormatDateBR(GetDateUSSemValue())}
                  empresa=""
                  endDate={FormatDateBR(meta.end_date)}
                  hoursCurrency={HandleGetHoursCurrency()}
                  nomePdf="Relatório de produção por gerente"
                  startDate={FormatDateBR(meta.start_date)}
                />
              )}

              <View
                key={meta.count}
                fixed
                style={{
                  borderBottom: "1px solid black",
                  marginBottom: "14px",
                }}
              >
                <ItemMapToInfoSearch
                  itens={meta?.gerente ? [meta.gerente] : []}
                  title="Gerente"
                />
                <ItemMapToInfoSearch
                  itens={[
                    meta.type_date
                      ? tiposDate[meta.type_date]
                      : tiposDate.ASSINATURA,
                  ]}
                  title="Tipo de data"
                />
              </View>

              <TableBase key={meta.count} margin="0">
                <HeadReportProductionGerente />

                {Children.toArray(
                  data.map((item) => (
                    <TableRowContainer key={item.gerente.id}>
                      <PDFTableRow
                        paddingLeft="8px"
                        title={`${item.gerente.id} - ${item.gerente.name}`}
                        width="30%"
                      />
                      <PDFTableRow
                        textAlign="right"
                        title={FormatMoney(Number(item.total_mensalidades).toFixed(2))}
                        width="30%"
                      />
                      <PDFTableRow
                        textAlign="center"
                        title={Number(item.total_contratos)}
                        width="20%"
                      />
                      <PDFTableRow
                        textAlign="center"
                        title={Number(item.total_vidas)}
                        width="20%"
                      />
                    </TableRowContainer>
                  ))
                )}

                <TableRowContainer backgroundColor="#eeeeee">
                  <PDFTableRow
                    fontSize={11}
                    paddingLeft="8px"
                    title={`Total - ${meta.count} Gerente${meta.count > 1 ? "s" : ""}`}
                    width="30%"
                  />

                  <PDFTableRow
                    fontSize={11}
                    textAlign="right"
                    title={FormatMoney(total.totalMensalidades.toFixed(2))}
                    width="30%"
                  />
                  <PDFTableRow
                    fontSize={11}
                    textAlign="center"
                    title={total.totalContratos}
                    width="20%"
                  />
                  <PDFTableRow
                    fontSize={11}
                    textAlign="center"
                    title={total.totalVidas}
                    width="20%"
                  />
                </TableRowContainer>
              </TableBase>

              <NumberPages />
            </PageCorePDF>
          </Document>
        </PDFViewer>
      )}

      {loadingGravar && (
        <Box style={{ width: "100%" }}>
          <LinearProgress color="inherit" />
        </Box>
      )}
    </>
  );
};
